import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackerManagementExperience.activityLogs'

const TrackerManagementTrackerActivityLogsSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackerManagementTrackerActivityLogsSlice
